import { Accordion, AccordionProps } from '@chakra-ui/accordion';
import React from 'react';

export const CmAccordion: React.FC<AccordionProps> = ({
  children,
  ...rest
}) => {
  // @ts-ignore TS2590
  return <Accordion {...rest}>{children}</Accordion>;
};
